// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '삼익제약',
  targetSheetName: '2026년 6월',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionRate: '정책',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '구 분',
    '번호',
    '성분명',
    '제품명',
    '주성분코드',
    '보험코드',
    '상한가',
    '정책',
    '생동',
    '제품 일정 및 프로모션 안내',
    '비고',
  ],
});
